// @ts-nocheck

import { Box, Button, Hidden, Paper } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { LogOut } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { logout } from '../../../actions/auth.action'
import AppLogo from '../../../assets/images/learnstage-logo.png'
import UploadImg from '../../../assets/images/upload-logo.png'
import RouterContext from '../../../contexts/route.context'
import { HELP_URL, ROUTES } from '../../../helpers/constants'
import { selectSchool, selectUser } from '../../../helpers/selectors'
import { noop } from '../../../helpers/utils'
import withRouteContext from '../../../hocs/RouterContextHOC'
import useStyles from '../Auth.Style'
import BottomLink from '../BottomLink'
import { fetchTemplatesCall } from './../../../actions/enrollment.action'

function RejectedInfo({ logout, user, school, fetchTemplatesCall }) {
  const classes = useStyles()
  const { t } = useTranslation()
  const { params } = useContext(RouterContext)
  const [rejectionMessage, setRejectionMessage] = React.useState('')
  React.useEffect(() => {
    if (!school.sch_id) {
      return
    }
    fetchTemplatesCall(
      school.sch_id,
      'application_rejection_message',
      (data) => {
        setRejectionMessage(data)
      },
      null,
      false
    )
  }, [school.sch_id])
  const logoutAndRedirect = () => {
    logout(params)
  }
  return (
    <Box px={{ xs: 2, sm: 3 }} pt={{ xs: 2, sm: 3 }} width="100%" className="rejected-info-section">
      <Box
        width="100%"
        flexGrow={0}
        display="flex"
        alignItems="center"
        justifyContent={{ xs: 'center', md: 'space-between' }}
        flexDirection="row"
      >
        <Box className="brand-logo">
          <img
            src={school.sch_logo || UploadImg}
            alt="Logo"
            onError={(e) => {
              e.target.onerror = null
              e.target.src = UploadImg
            }}
          />
        </Box>
        <Hidden smDown>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            flexDirection="row"
            fontWeight="fontWeightMedium"
            fontSize="14px"
          >
            <Button
              className="custom-default-button text-transform-none"
              size="large"
              variant="contained"
              disableElevation
              onClick={logoutAndRedirect}
              endIcon={<LogOut />}
            >
              {user.email}
            </Button>
          </Box>
        </Hidden>
      </Box>

      <Box mt={3} mb={3} px={3} className={classes.rejectedInfo}>
        <Paper rounded="true" elevation={1} className={classes.signUpBody + ' paper-round'}>
          <Box
            px={{ xs: 2, sm: 3 }}
            pt={{ xs: 2, sm: 3 }}
            width="100%"
            mb={3}
            className={classes.studentInfo}
          >
            <Box mb={3} px={3}>
              <Typography
                component="div"
                align="center"
                variant="h5"
                color="textPrimary"
                gutterBottom
              >
                <Box width="100%" component="span" fontWeight="600" fontSize="32px">
                  {t('sorry')}
                </Box>
              </Typography>
              <Typography
                component="div"
                align="center"
                variant="h5"
                color="textPrimary"
                gutterBottom
              >
                {rejectionMessage ? (
                  <Box
                    width="100%"
                    component="span"
                    fontWeight="600"
                    dangerouslySetInnerHTML={{
                      __html: rejectionMessage,
                    }}
                    fontSize="16px"
                  ></Box>
                ) : null}
              </Typography>
              <Typography component="div" align="center" variant="body2" color="textSecondary">
                <Box width="100%" component="span" fontWeight="500">
                  {school?.sch_address?.adr_phone
                    ? t('schoolStatusInfoDescriptionWithNumber', {
                        schoolName: school.sch_name,
                        schoolPhonePrefix: school.sch_phone_prefix,
                        schoolPhone: school.sch_phone,
                        officePhonePrefix: school?.sch_address?.adr_phone_prefix,
                        officePhone: school?.sch_address?.adr_phone,
                      })
                    : t('schoolStatusInfoDescription', {
                        schoolName: school.sch_name,
                        schoolPhonePrefix: school.sch_phone_prefix,
                        schoolPhone: school.sch_phone,
                      })}
                </Box>
              </Typography>
              <Box pb={3} px={{ xs: 2, sm: 3 }}>
                <Box
                  mt={{ xs: 2, sm: 4 }}
                  mb={{ xs: 0, sm: 4 }}
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Typography component="h4" variant="body2" color="primary">
                    <Box component="span" fontWeight="fontWeightMedium">
                      <a className="link-text" href={HELP_URL} target="_blank" rel="noreferrer">
                        {t('needHelp')}
                      </a>
                    </Box>
                  </Typography>
                  <Hidden mdUp>
                    <Box
                      mt={5}
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-start"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      fontWeight="fontWeightMedium"
                      fontSize="14px"
                      className="link-color"
                    >
                      <Box mr={1} component="span">
                        {t('newMember')}
                      </Box>
                      <Link linkClassName="link-color-text" to={ROUTES.REGISTER}>
                        {t('registerNow')}
                      </Link>
                    </Box>
                  </Hidden>
                </Box>
                <BottomLink />
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>

      <Box
        px={3}
        py={2}
        width="100%"
        flexGrow={0}
        display="flex"
        alignItems="center"
        justifyContent={{ xs: 'center', md: 'flex-end' }}
      >
        <img src={AppLogo} alt="logo" />
      </Box>
    </Box>
  )
}

RejectedInfo.propTypes = {
  user: PropTypes.object,
  logout: PropTypes.func,
  school: PropTypes.object,
  fetchTemplatesCall: PropTypes.func,
}

RejectedInfo.defaultProps = {
  user: {},
  logout: noop,
  school: {},
  fetchTemplatesCall: noop,
}

const mapStateToProps = (state) => ({
  user: selectUser(state),
  school: selectSchool(state),
})

export default withRouteContext(
  connect(mapStateToProps, {
    logout,
    fetchTemplatesCall,
  })(RejectedInfo)
)
